export default __webpack_public_path__ + "static/media/magical-risk-image.e6fa7be0.png";